module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9218bcead8c823078f24d088bae4dc6c.png";